import { createContext, ReactNode } from "react";

import { useProjectStore } from "./Project/useProjectStore";
import { useUserManagementStore } from './UserManagement/useUserManagementStore';

type Stores = {
  projectStore: ReturnType<typeof useProjectStore>;
  userManagementStore: ReturnType<typeof useUserManagementStore>;
};

export const RootStoreContext = createContext<Stores | null>(null);

type Props = {
  children: ReactNode;
};

export const RootStoreProvider = ({ children }: Props) => {
  const stores = {
    projectStore: useProjectStore(),
    userManagementStore: useUserManagementStore()
  };

  return (
    <RootStoreContext.Provider value={stores}>
      {children}
    </RootStoreContext.Provider>
  );
};
